'use client'

import { memo, useEffect, useRef } from 'react'

import { useParams, useRouter } from 'next/navigation'

import { useAppDispatch, useAppSelector } from '@/redux/hooks'

import { initializeFilter, setUpdateUrl } from '../../model/catalogSlice'
import type { TFilterOption } from '../../model/filterTypes'

interface IClientActionsProps {
    filterData: TFilterOption[] | undefined
    catalogParams: string[] | null
}

export const ClientActions = memo(function ClientActions({ filterData, catalogParams }: IClientActionsProps) {
    const navigate = useRouter()
    const initialized = useRef(false)
    const dispatch = useAppDispatch()
    const params = useParams()

    const { updateUrl, filter } = useAppSelector(state => state.catalog)

    useEffect(() => {
        if (filterData && !initialized.current) {
            dispatch(initializeFilter({ filterData, catalogParams }))
            initialized.current = true
        }
    }, [dispatch, filterData, catalogParams, initialized.current])

    useEffect(() => {
        if (updateUrl) {
            if (
                params.catalog &&
                !filterData.find(option =>
                    option.items.find(item => item.value === decodeURIComponent(params.catalog?.[0]))
                )
            ) {
                navigate.push(`/catalog/${params.catalog[0]}/${updateUrl === 'catalog' ? '' : updateUrl}`)
            } else navigate.push(`/catalog/${updateUrl === 'catalog' ? '' : updateUrl}`)

            dispatch(setUpdateUrl(false))
        }
    }, [updateUrl, filterData, navigate, params])

    return <></>
})
